module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/config",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-gear"
  }), _c('span', [_vm._v("Konfigurasi Aplikasi")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f2af04c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config_management/Navigation.vue
// module id = 1326
// module chunks = 0